import { Routes } from '@angular/router'
import { LandingPageComponent } from './pages/landing/landing.component'
import { AuthGuard } from './guards/auth.guard'
import { SdkGuard } from './guards/sdk.guard'
import { NavigationProxyGuard } from './guards/navigation-proxy.guard'
import { FaqComponent } from './components/faq/faq.component'
import { ErrorComponent } from './components/error/error.component'
import { PurchaseHistoryComponent } from './components/purchase-history/purchase-history.component'
import { WebsiteTermsOfUseComponent } from './components/website-terms-of-use/website-terms-of-use.component'
import { ConnectedPrivacyPolicyComponent } from './components/connected-privacy-policy/connected-privacy-policy.component'
import { ConnectedTermsOfServiceComponent } from './components/connected-terms-of-service/connected-terms-of-service.component'
import { ContactUsComponent } from './components/contact-us/contact-us.component'
import { PlansAndPricingComponent } from './components/plans-and-pricing/plans-and-pricing.component'

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/en-US',
  },
  {
    path: ':culture',
    canActivate: [SdkGuard, NavigationProxyGuard],
    children: [
      {
        path: '',
        component: LandingPageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'login',
        loadChildren: () =>
          import('./modules/login/login.module').then((m) => m.LoginModule),
      },
      {
        path: 'faq',
        component: FaqComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'purchase-history',
        component: PurchaseHistoryComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'website-terms-of-use',
        component: WebsiteTermsOfUseComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'connected-privacy-policy',
        component: ConnectedPrivacyPolicyComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'connected-terms-of-service',
        component: ConnectedTermsOfServiceComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'contact-us',
        component: ContactUsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'plans-and-pricing',
        component: PlansAndPricingComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./modules/home/home.module').then((m) => m.HomeModule),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'vehicles',
        loadChildren: () =>
          import('./modules/vehicles/vehicles.module').then(
            (m) => m.VehiclesModule
          ),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'solutions',
        loadChildren: () =>
          import('./modules/solutions/solutions.module').then(
            (m) => m.SolutionsModule
          ),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./modules/products/products.module').then(
            (m) => m.ProductsModule
          ),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'user-profile',
        loadChildren: () =>
          import('./modules/user-profile/user-profile.module').then(
            (m) => m.UserProfileModule
          ),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('./modules/payment/payment.module').then(
            (m) => m.PaymentModule
          ),
        canActivateChild: [AuthGuard],
      },
      {
        path: 'error',
        component: ErrorComponent,
        canActivate: [AuthGuard],
      },
      {
        path: '**',
        redirectTo: '/error',
      },
    ],
  },
]
